/**
 * The IDL of the module.
 *
 * @module
 */
/** The IDL of the module. */
export const idl = {
  module_id: "0x1::hash",
  doc: "Module which defines SHA hashes for byte vectors.\n\nThe functions in this module are natively declared both in the Move runtime\nas in the Move prover's prelude.",
  functions: [],
  structs: [],
  errors: {},
} as const;
